import angular from 'angular';

import TeamService from './team.service';

export default angular
    .module('application.service.team', [])
    .service('teamService', TeamService);



// WEBPACK FOOTER //
// ./src/application/service/team/index.js